import { FC } from 'react';
import AmericanExpressIcon from '@assets/images/partners/amex.png';
import useStyles from './styles';

const AmexIcon: FC = (props) => {
  const css = useStyles();

  return (
    <span className={css.container}>
      <img src={AmericanExpressIcon} {...props} />
    </span>
  );
};

export default AmexIcon;
